const Select = ({
  label,
  error,
  helper,
  id,
  options = [],
  placeholder,
  className = '',
  ...props
}) => {
  const selectId = id || label?.toLowerCase().replace(/\s+/g, '-');

  return (
    <div>
      {label && (
        <label htmlFor={selectId} className="input-label">
          {label}
        </label>
      )}
      <select
        id={selectId}
        className={`select ${error ? 'input-error' : ''} ${className}`}
        aria-invalid={error ? 'true' : undefined}
        {...props}
      >
        {placeholder && <option value="">{placeholder}</option>}
        {options.map((opt) => (
          <option key={opt.value} value={opt.value}>
            {opt.label}
          </option>
        ))}
      </select>
      {error && (
        <p className="input-error-text" role="alert">
          {error}
        </p>
      )}
      {helper && !error && <p className="input-helper">{helper}</p>}
    </div>
  );
};

export default Select;
